<template>
  <div>
    <el-tabs v-model="mergeForm.cpid" @tab-click="handleTabsClick">
      <el-tab-pane
        v-for="item in shippingCompanyOptions"
        :key="item.cpid"
        :label="item.shipping_company"
        :name="item.cpid"
      >
        <ys-data-table
          v-if="item.cpid == mergeForm.cpid"
          v-model="refresh"
          :list="searchList"
          :button-list="buttonList"
          :columns="columns"
          :fetch-method="fetchMethod"
          :transform-params="handleFormatSearch"
          page-size-alias="pageSize"
          :page-sizes="[100, 200, 300, 400, 1000]"
          :page-size="1000"
          use-data-field
          @on-fetch-success="handleFetchSuccess"
        >
          <template slot="upload">
            <el-upload
              :action="action"
              name="file"
              :data="{
                cpid: item.cpid,
                stock_storehouse_id: mergeForm.stock_storehouse_id,
              }"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :show-file-list="false"
              with-credentials
            >
              <el-button size="small" type="primary">
                地区快递费用设置导入</el-button
              >
            </el-upload>
          </template>
          <template slot="log">
            <el-button type="primary" @click="handlesDialogOpen">
              修改日志
            </el-button>
          </template>
        </ys-data-table>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="修改日志："
      :visible.sync="dialogVisible"
      width="600px"
      @close="handleDialogClose"
    >
      <el-table :data="logTableData" border style="width: 100%">
        <el-table-column prop="update_admin" label="更新人" width="180">
        </el-table-column>
        <el-table-column prop="updated_at" label="更新时间" width="180">
        </el-table-column>
        <el-table-column prop="file_url" label="更新文件">
          <template slot-scope="scope">
            <i class="el-icon-document" />
            <el-button type="text" @click="handleDownload(scope.row.file_url)">
              下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

import {
  rateList,
  rateShippingCompany,
  rateLog,
} from "@/controller/wavePickingShipping.js";

export default {
  name: "ShippingAgingList",
  props: {
    originId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      mergeForm: {
        stock_storehouse_id: "",
        cpid: "1",
      },
      columns: [],
      dialogVisible: false,
      fetchMethod: rateList,
      buttonList: [
        {
          tag: "button",
          text: "导出",
          props: {
            type: "success",
          },
          event: {
            handler: (params) => rateList({ ...params, is_excel: "1" }),
            success: (res) => window.open(apiBaseURL + res.file),
          },
        },
        {
          tag: "custom",
          slot: "upload",
        },
        {
          tag: "custom",
          slot: "log",
        },
      ],
      searchList: [],
      refresh: false,
      logTableData: [],
      shippingCompanyOptions: [],
      action: `${apiBaseURL}/erp/WavePickingShipping/rateImport`,
    };
  },
  watch: {
    originId(val) {
      this.mergeForm.stock_storehouse_id = val;
      this.refresh = true;
    },
  },
  created() {
    this.mergeForm.stock_storehouse_id = this.originId;
    this.getColumns();
    this.refresh = true;
  },
  methods: {
    handleFormatSearch(params) {
      const result = {
        ...this.mergeForm,
        ...params,
      };
      return result;
    },
    handleTabsClick() {
      this.refresh = true;
    },
    // 获取所有快递公司表头
    getColumns() {
      rateShippingCompany().then((data) => {
        const { list } = data;
        this.shippingCompanyOptions = list;
      });
    },
    handleFetchSuccess(data) {
      this.columns = data.header;
    },
    handleUploadSuccess(data) {
      if (data.code !== 200) {
        this.$message.error(data.msg);
      } else {
        this.$message.success("导入成功");
        if ((data.data || {}).file) {
          window.open(apiBaseURL + data.data.file);
        }
      }
    },
    handleUploadError() {
      this.$message.warning("导入失败！");
    },
    // 查看日志
    handlesDialogOpen() {
      rateLog({
        stock_storehouse_id: this.originId,
        cpid: this.mergeForm.cpid,
      }).then((data) => {
        const { list } = data;
        this.logTableData = list;
        this.dialogVisible = true;
      });
    },
    handleDialogClose() {
      this.dialogVisible = false;
    },
    handleDownload(fileUrl) {
      window.open(fileUrl);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/wavepicking/ShippingRule/components/ExpressRateSchedule.vue